<ng-container *ngFor="let item of loopCounter()">
	<div class="list-view-loader">
		<div class="title">
			<app-square-skeleton width="80%" height="10px"></app-square-skeleton>
		</div>
		<div class="second-section-wrapper">
			<div class="wrapper">
				<app-square-skeleton width="80%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="75%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="60%" height="10px"></app-square-skeleton>
			</div>
      <div class="wrapper">
				<app-square-skeleton width="80%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="90%" height="10px"></app-square-skeleton>
			</div>
			<div class="wrapper">
				<app-square-skeleton width="60%" height="10px"></app-square-skeleton>
			</div>
		</div>
	</div>
</ng-container>